import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/vorgaenge.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/vorgaenge')({
  component: Content,
});
